import React, { useState, useEffect } from "react";

const stateOptions = [
  "California",
  "Connecticut",
  "Florida",
  "Massachusetts",
  "New Hampshire",
  "Washington",
];

const StateQuestion = ({ onSubmit, onNext, initialValue, isEditing }) => {
  const [selectedState, setSelectedState] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (initialValue) {
      setSelectedState(initialValue);
    }
  }, [initialValue]);

  const handleStateChange = (state) => {
    setSelectedState(state);
    // Don't call onSubmit here - only when Continue is clicked
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedState) return;
    
    onSubmit(selectedState);
    onNext();
    
    // Reset selection
    setSelectedState("");
  };

  const canSubmit = selectedState !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="state-options-container">
        <div className="state-options">
          {stateOptions.map((option) => (
            <button
              key={option}
              type="button"
              className={`state-button ${selectedState === option ? 'state-button-selected' : ''}`}
              onClick={() => handleStateChange(option)}
            >
              {option}
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="state-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default StateQuestion; 